import React from 'react';
import Img from '../Img';
import { TbFlag } from 'react-icons/tb';
import { PRODUCT_TAG_FLAG_CATEGORY_COUNTRY } from '../../../Utils/Constants/Product';

interface BadgeProductTagFlagProps {
    product: any;
    className?: string;
}

const BadgeProductTagFlag = ({
    product,
    className,
}: BadgeProductTagFlagProps) => {

    if (!product) return null;

    const tagFlag = product.tags.find((tag: any) => tag.tag_category_id === PRODUCT_TAG_FLAG_CATEGORY_COUNTRY && tag.icon);

    if (!tagFlag) return null;

    console.log('tagFlag', tagFlag);
    return (
        <Img
            alt={tagFlag.name}
            title={tagFlag.name}
            className={`${className} w-[15%] aspect-square w-full max-w-8 min-w-5 aspect-square shadow-md shadow-black/20 rounded-full`}
            src={tagFlag.icon}
            fallback={
                <div className='flex items-center justify-center w-full h-full bg-gray-800/20 rounded-full text-sm'>
                    <TbFlag className='text-white' />
                </div>
            }
        />
    );

};

export default BadgeProductTagFlag;
